import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie } from "../../helperFunctions/cookies";
import { CLIENT_COOKIE_KEY } from "../../utils/constants";

export const AuthLayout = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    const token = getCookie(CLIENT_COOKIE_KEY);

    const isAuthenticated = !!token ? true : false;

    if (isAuthenticated) {
      navigate("/app/overview");
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <div className="flex flex-row w-full h-screen max-h-[100dvh]">
      <div
        className="
        lg:w-6/12 hidden lg:block bg-light-green-bg-200
        bg-[length:100%]
        p-[64px]
        bg-no-repeat bg-bottom
        "
        style={{
          backgroundImage: "url('/assets/images/onboarding_bg.svg')",
        }}
      >
        <img
          src="/assets/images/logo.svg"
          alt="logo"
          className="W-[182px] block h-[32px]"
        />

        <h1 className="tracking-[-0.02em] text-[40px] mt-[80px] font-black leading-[130%]">
          Everything Cooperative.
          <br />
          <span className="text-pry-green-200">One Platform.</span>
        </h1>

        <h2 className="mt-4 text-xl text-text-gray">
          Managing your cooperative activities is now made easy with Thriftcorp
        </h2>
      </div>

      <div
        className="
        w-full lg:w-6/12
        py-4 md:py-4 lg:py-4
        px-7 items-center gap-10
        flex justify-center flex-col
        overflow-y-scroll
        bg-no-repeat bg-[center_calc(100%+200px)] bg-contain !bg-none
      "
        style={{
          backgroundImage: "url('/assets/images/onboarding_bg.svg')",
        }}
      >
        <img
          src="/assets/images/logo-icon.svg"
          alt="logo"
          className="min-w-[50px] max-w-[50px] aspect-square hidden lg:hidden mr-auto"
        />

        <div className="flex min-h-fit items-center justify-center w-full flex-1">
          {children}
        </div>
      </div>
    </div>
  );
};
